
import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const StyleWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50px;
    background-color: rgba(42, 38, 39, 1);
    color: #fff;
    letter-spacing: 0.07em;
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/components/Footer/Wrapper.js